import React, { Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth, scrollToTopValidate, scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl,  mediaUrl} from'../Config/Config';
import axios from 'axios';
import { ShadowPicker } from "react-shadow-picker";
const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
class Add extends Component {
	
	fileObj = [];
    fileArray = [];
    imageArray = [];
	
	constructor(props)
	{
		CheckAuth();
		super(props);	
		this.state = {
			title:'',
			
			status:'A',
		  selectedFile: null,
			Loading:false,
			selectedvalue: '',
      selectedOption:{ value: 'active', label: 'Active'},
			selectedFileCount : 0,

			shadow: "",
			shadows: {
				shadowPluginOpenButton: "inset 10px 0px 10px 0px #b7b7b785",
				shadowPluginOpenButtonInset: "inset 10px 0px 10px 0px #b7b7b785",
				largeButton: "0 4px 18px 0 #0404052e",
				shadowButtonInset: "inset 5px 0px 5px 0px #3434372b",
				dashboardShadowGrid: "0 10px 21px 0 #0000001c",
				shadowDashboardGridInset: "inset 5px 0px 5px 0px #3434372b",
				dashboardShadowList: "0 21px 21px 0 #0000001c",
				shadowDashboardListInset: "inset 5px 0px 5px 0px #3434372b",
				dropdownmenu: "0px 3px 21px 0px #9f99995c",
				shadowDropdownMenuInset: "inset 5px 0px 5px 0px #3434372b",
				shadowSearchDropdown: "-2px 10px 15px #3434375e",
				shadowSearchDropdownInset: "inset 5px 0px 5px 0px #3434372b",
				shadowMapPopup: "-2px 10px 15px #3434375e",
				shadowMapPopupInset: "inset 5px 0px 5px 0px #3434372b",
				shadowTopPopup: "1px 0px #0000000c",
				shadowTopPopupInset: "1px 0px #0000000c",
				shadowLeftSidebar: "-2px 10px 15px #3434375e",
				shadowLeftSidebarInset: "inset 5px 0px 5px 0px #3434372b",
				shadowRightSidebar: "-2px 10px 15px #3434375e",
				shadowRightSidebarInset: "inset 5px 0px 5px 0px #3434372b",
				shadowAISidebar: "1px 0px #0000000c",
				shadowAISidebarInset: "inset 5px 0px 5px 0px #3434372b",
				shadowMainAITextarea: "0px 3px 21px 0px #9f99995c",
				shadowMainAITextareaInset: "inset 5px 0px 5px 0px #3434372b",
        shadowFormGroup: "0px 3px 21px 0px #9f99995c",
        shadowFormGroupInset: "inset 5px 0px 5px 0px #3434372b",
				shadowInput: "inset 5px 0px 5px 0px #3434372b",
				shadowText: "0 7px 10px -7px #04040422c",
				shadowListRow: "1px 0px #0000000c",
				shadowTableRow: "1px 0px #0000000c",
        
        
				pluginShadow: "0px 24px 34px #0404052e",
				// sideMenu:"-2px 10px 15px #3434375e",
				// pluginInset: "5px 0px 15px 0 #3434372b",
				// smallButton: '0 18px 21px 0 #000',
				textarea: "0 7px 10px -7px #04040422",
				pluginInsideLeftShadow: "15px 0 20px -10px #9898983d",
				pluginInsideRightShadow: "-15px 0 20px -10px #9898983d",
				pluginInsideTopShadow: "0 15px 20px -10px #9898983d",
				pluginInsideBottomShadow: "0 -15px 20px -10px #9898983d",
				shortcutMenu: "0px 3px 21px 0px #9f99995c",
				shortcutMenuInset: "0px 3px 21px 0px #9f99995c",
				// sidePopup: '0 18px 21px 0 #000',
			},
			activeShadowType: "largeButton",

			line_height    	: '1.5',
			pluginRadius    : '30',
			dropdownRadius  : '10',
			inputRadius    	: '10',
			textareaRadius  : '10',
			dashboardGridRadius  : '10',
			dashboardListRadius  : '10',
			listRowRadius  : '10',
			mapPopupRadius  : '10',
			formGroupRadius  : '10',
			mainAITextareaRadius  : '10',
			topPopupRadius  : '10',
      ai_side_menu_width: "",
      st_aisidebar_collapsed_width: "",
      st_aisidebar_icon_width: "",


			// fontDetails: [
      //   { index: 1, FontType: "primary", listName: "Primary", font_id : 193, fontSize: "22", fontWeight: "500", letterSpacing: "2", lineHeight: "1.5", topSpace: "", bottomSpace: "", radius: "" },
      //   { index: 2, FontType: "menuLogo", listName: "Menu Logo", font_id : 193, fontSize: "28", fontWeight: "700", letterSpacing: "2", lineHeight: "1.5", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 3, FontType: "mainTab", listName: "Main Tab", font_id : 193, fontSize: "22", fontWeight: "600", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 4, FontType: "sideMenu", listName: "Side Menu", font_id : 193, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 5, FontType: "title", listName: "Title", font_id : 193, fontSize: "24", fontWeight: "800", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 6, FontType: "subTitle", listName: "Sub Title", font_id : 193, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 7, FontType: "listFont", listName: "List Font", font_id : 193, fontSize: "22", fontWeight: "500", letterSpacing: "2", lineHeight: "1.5", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 8, FontType: "listTitleFont", listName: "List Title Font", font_id : 193, fontSize: "22", fontWeight: "600", letterSpacing: "2", lineHeight: "1.5", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 9, FontType: "listSerialNoFont", listName: "List Serial No Font", font_id : 193, fontSize: "22", fontWeight: "600", letterSpacing: "1.5", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 10, FontType: "dashboardList", listName: "Dashboard List", font_id : 193, fontSize: "22", fontWeight: "600", letterSpacing: "1.5", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 11, FontType: "dashboardListCount", listName: "Dashboard List Count", font_id : 193, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 12, FontType: "largebutton", listName: "Large Button", font_id : 193, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "1.5", topSpace: "20", bottomSpace: "15", radius: "11" },
			// 	{ index: 13, FontType: "smallbutton", listName: "Small Button", font_id : 193, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "1.5", topSpace: "8", bottomSpace: "3", radius: "11" },
			// 	{ index: 14, FontType: "pluginOpenButton", listName: "Plugin Open Button", font_id : 193, fontSize: "32", fontWeight: "700", letterSpacing: "2", lineHeight: "", topSpace: "22", bottomSpace: "10", radius: "15" },
			// 	{ index: 15, FontType: "mainAISidebarChatSummaryTitle", listName: "AI Chat Summary Title", font_id : 193, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 16, FontType: "mainAISidebarChatSummary", listName: "AI Chat Summary", font_id : 193, fontSize: "22", fontWeight: "500", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 17, FontType: "mainAISidebarProfile", listName: "AI Profile Name", font_id : 193, fontSize: "24", fontWeight: "700", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			// 	{ index: 18, FontType: "formLabel", listName: "Form Label", font_id : 193, fontSize: "22", fontWeight: "700", letterSpacing: "2", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },

        
				
			// ],

      fontDetails: [
        { index: 1, FontType: "primary", listName: "Primary", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
        { index: 2, FontType: "menuLogo", listName: "Menu Logo", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 3, FontType: "mainTab", listName: "Main Tab", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 4, FontType: "sideMenu", listName: "Side Menu", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 5, FontType: "title", listName: "Title", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 6, FontType: "subTitle", listName: "Sub Title", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 7, FontType: "listFont", listName: "List Font", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 8, FontType: "listTitleFont", listName: "List Title Font", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 9, FontType: "listSerialNoFont", listName: "List Serial No Font", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 10, FontType: "dashboardList", listName: "Dashboard List", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 11, FontType: "dashboardListCount", listName: "Dashboard List Count", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 12, FontType: "largebutton", listName: "Large Button", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 13, FontType: "smallbutton", listName: "Small Button", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 14, FontType: "pluginOpenButton", listName: "Plugin Open Button", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 15, FontType: "mainAISidebarChatSummaryTitle", listName: "AI Chat Summary Title", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 16, FontType: "mainAISidebarChatSummary", listName: "AI Chat Summary", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 17, FontType: "mainAISidebarProfile", listName: "AI Profile Name", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
				{ index: 18, FontType: "formLabel", listName: "Form Label", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
        { index: 19, FontType: "formInputPlaceHolder", listName: "Form Input Placeholder", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
        { index: 20, FontType: "formInputValue", listName: "Form Input Value", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
        { index: 21, FontType: "subTab", listName: "Sub Tab", font_id : '', fontSize: "", fontWeight: "", letterSpacing: "", lineHeight: "", topSpace: "", bottomSpace: "", radius: "" },
			],
			fonttype: [],
			selectedFont: "",
			selectedFontVariant: "",
			st_varient_id: [],
		};
		
	   this.handleInputChange = this.handleInputChange.bind(this);
	   this.handleChange = this.handleChange.bind(this);
    }
	

   handleInputChange(event) {

      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
    }

     handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };
	componentDidMount() {
		document.title = PageTitle('Theme Add');

		var admin_id = localStorage.getItem('admin_id');
		axios.get(apiUrl+'font/getfont_name?admin_id='+admin_id).then(res => {
			if(res.data.status == 'success'){
				this.setState({
					fonttype: res.data.fontlist
				}, () => {
          // 🔹 After fonts are loaded, preload variants for existing fontDetails
          this.state.fontDetails.forEach((font, idx) => {
            if (font.font_id) {
              this.preloadFontVariants(font.font_id, idx);
            }
          })
        })
			}
		});
  }
  preloadFontVariants = async (fontValue, idx) => {
    try {
      // Find label from fonttype list
      const selectedFont = this.state.fonttype.find(f => f.value == fontValue);
      const fontLabel = selectedFont ? selectedFont.label : "";

      const response = await axios.get(`${apiUrl}font/getvarientlistdetail`, {
        params: {
          id: fontValue,
          name: fontLabel,
        },
      });

      if (response.data.variants) {
        let fontDetails = [...this.state.fontDetails];
        fontDetails[idx] = {
          ...fontDetails[idx],
          variants: response.data.variants,
        };
        this.setState({ fontDetails });
      }
    } catch (error) {
      console.error("Error preloading font variants:", error);
    }
  };

	handleFormSubmit = () => {
		if(this.validateForm()){
			this.setState({Loading:true});
			const config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			};

			const formPayload = this.state;
			var qs = require('qs');
			var status = '';
			if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
			status =formPayload.selectedOption.value;
			}else{
			status = formPayload.selectedvalue;
			}
			var admin_id = localStorage.getItem("admin_id");
			var postObject = {
				admin_id     	: admin_id,
				title    		: formPayload.title,
				line_height    	: formPayload.line_height,
				pluginRadius    : formPayload.pluginRadius,
				dropdownRadius  : formPayload.dropdownRadius,
				inputRadius    	: formPayload.inputRadius,
				textareaRadius  : formPayload.textareaRadius,
				dashboardGridRadius  : formPayload.dashboardGridRadius,
				dashboardListRadius  : formPayload.dashboardListRadius,
				listRowRadius  : formPayload.listRowRadius,
				mapPopupRadius  : formPayload.mapPopupRadius,
				formGroupRadius  : formPayload.formGroupRadius,
				mainAITextareaRadius  : formPayload.mainAITextareaRadius,
				topPopupRadius  : formPayload.topPopupRadius,
        ai_side_menu_width: formPayload.ai_side_menu_width,
        st_aisidebar_collapsed_width: formPayload.st_aisidebar_collapsed_width,
        st_aisidebar_icon_width: formPayload.st_aisidebar_icon_width,
				fontDetails:JSON.stringify(formPayload.fontDetails),
				shadow: JSON.stringify(this.state.shadows),
			};

			let formData = new FormData();
			for(let k in postObject) {
			formData.append(k, postObject[k]);
			}
									
			axios.post(apiUrl+"thememanagement/add",formData,config).then(res => {
				if(res.data.status === "success"){
					this.setState({ Loading: false });
					$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');

					scrollToTop();
							setTimeout(
							function() {
								$('.success_message').html('');
								this.props.navigate('/theme');
							}
							.bind(this),
							3000
							);
				} else {
					this.setState({ Loading: false });
					$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
					scrollToTop();
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
				}
			});
		}
	}

	validateForm() {
		const {title, fontDetails, ai_side_menu_width, st_aisidebar_icon_width, st_aisidebar_collapsed_width} = this.state;

		let errors = 0;
		if (!title) {
			errors++;
			$('.errortitle').html('<span class="errorspan">Please fill the field</span>');
		}else if(title){
			$('.errortitle').html('');
		}

    if (!ai_side_menu_width) {
			errors++;
			$('.errorsai_side_menu_width').html('<span class="errorspan">Please fill the field</span>');
		}else if(ai_side_menu_width){
			$('.errorsai_side_menu_width').html('');
		}
		if (!st_aisidebar_icon_width) {
			errors++;
			$('.errorsst_aisidebar_icon_width').html('<span class="errorspan">Please fill the field</span>');
		}else if(st_aisidebar_icon_width){
			$('.errorsst_aisidebar_icon_width').html('');
		}
		if (!st_aisidebar_collapsed_width) {
			errors++;
			$('.errorsst_aisidebar_collapsed_width').html('<span class="errorspan">Please fill the field</span>');
		}else if(st_aisidebar_collapsed_width){
			$('.errorsst_aisidebar_collapsed_width').html('');
		}

		// Font details validation
		fontDetails.forEach((font, idx) => {
			// Reset previous errors
			$(`.errorfile${idx}`).html('');
			$(`.fontVariantError${idx}`).html('');
			$(`.fontFamilyError${idx}`).html('');
			$(`.fontSizeError${idx}`).html('');
			$(`.letterSpacingError${idx}`).html('');
			$(`.topSpaceError${idx}`).html('');
			$(`.bottomSpaceError${idx}`).html('');
			$(`.radiusError${idx}`).html('');		

			if (!font.font_id || font.font_id === "") {
				errors++;
				$(`.fontFamilyError${idx}`).html('<span class="errorspan">Select a font family</span>');
			}
			if (!font.fontWeight || font.fontWeight === "") {
				errors++;
				$(`.fontVariantError${idx}`).html('<span class="errorspan">Select a font variant</span>');
			}
			if (!font.fontSize || isNaN(font.fontSize)) {
				errors++;
				$(`.fontSizeError${idx}`).html('<span class="errorspan">Enter valid font size</span>');
			}
			if (font.letterSpacing === "" || isNaN(font.letterSpacing)) {
				errors++;
				$(`.letterSpacingError${idx}`).html('<span class="errorspan">Enter valid letter spacing</span>');
			}			

			if (["smallbutton", "largebutton", "pluginOpenButton"].includes(font.FontType)) {
				if (!font.topSpace || isNaN(font.topSpace)) {
					errors++;
					$(`.topSpaceError${idx}`).html('<span class="errorspan">Enter valid top space</span>');
				}
				if (!font.bottomSpace || isNaN(font.bottomSpace)) {
					errors++;
					$(`.bottomSpaceError${idx}`).html('<span class="errorspan">Enter valid bottom space</span>');
				}
				if (!font.radius || isNaN(font.radius)) {
					errors++;
					$(`.radiusError${idx}`).html('<span class="errorspan">Enter valid radius</span>');
				}
			}
		});

	

		if(errors>0) {
			setTimeout(function () {
				scrollToTopValidate();
			}, 100);
			return false;
		}
		else {
			return true;
		}
    }

    componentWillReceiveProps(Props){

		if(Props.themeadd !== this.props.themeadd){
    		if(Object.keys(Props.themeadd).length > 0){
				this.setState({Loading:false});
				if(Props.themeadd[0].status === "success"){
					$('.success_message').html('<div class="status_sucess"><h3>'+Props.themeadd[0].message+'</h3></div>');
					setTimeout(
					function() {
						$('.success_message').html('');
						this.props.navigate('/themes');
					}
					.bind(this),
					3000
					);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+Props.themeadd[0].message+'</h3></div>');
					setTimeout(
					function() {
						$('.success_message').html('');
					}
					.bind(this),
					3000
					);
				}
    		}
    	}
    }

	/**Shadow start */
	handleSubmit = () => {
    const popup = document.querySelector(".input-popup-action");
    if (popup) {
      popup.classList.remove("show");
    }
	};

	confirmPopup = (type) => {
    this.setState({ activeShadowType: type });
    $(".input-popup-action").addClass("show");
  };
 	handleShadowChange = (value) => {
		this.setState((prevState) => ({
		shadows: {
			...prevState.shadows,
			[this.state.activeShadowType]: value,
		},
		}));
	};

	handleCancel = () => {
		const popup = document.querySelector(".input-popup-action");
		if (popup) {
			popup.classList.remove("show");
		}
	};

	labelFor = (key) => {
		const labels = {
			shadowPluginOpenButton: "Plugin Open Button Shadow",
			shadowPluginOpenButtonInset: "Plugin Open Inside Button Shadow",
			largeButton: "Button Shadow (Large, Small)",
			shadowButtonInset: "Button Inside Shadow (Large, Small)",
			dashboardShadowGrid: "Dashboard Grid Shadow",
			shadowDashboardGridInset: "Dashboard Grid Inside Shadow",
			dashboardShadowList: "Dashboard List Shadow",
			shadowDashboardListInset: "Dashboard List Inside Shadow",
			dropdownmenu:"Dropdown Menu Shadow (Bell notification, Group menu in listing screen, Message box, Address dropdown)",
			shadowDropdownMenuInset:"Dropdown Menu Inside Shadow (Bell notification, Group menu in listing screen, Message box, Address dropdown)",
			shadowSearchDropdown:"Search Dropdown Shadow (Pickup and Where location dropdown) ",
			shadowSearchDropdownInset:"Search Dropdown Inside Shadow (Pickup and Where location dropdown) ",
			shadowMapPopup: "Map Popup Shadow (View Map) ",
			shadowMapPopupInset: "Map Popup Inside Shadow (View Map) ",
			shadowTopPopup: "Top Popup Shadow (Add cards)",
			shadowTopPopupInset: "Top Popup Inside Shadow (Add cards)",
			shadowLeftSidebar: "Left Sidebar Shadow (Side Menu)",
			shadowLeftSidebarInset: "Left Sidebar Inside Shadow (Side Menu)",
			shadowRightSidebar:"Right Sidebar Shadow (Chat window, Guest Payment Form)",
			shadowRightSidebarInset:"Right Sidebar Inside Shadow (Chat window, Guest Payment Form)",
			shadowAISidebar: "AI Sidebar Shadow",
			shadowAISidebarInset: "AI Sidebar Inside Shadow",
			shadowMainAITextarea: "AI Screen Textarea Shadow",
			shadowMainAITextareaInset: "AI Screen Textarea Inset Shadow",
      shadowFormGroup: "Form Group Shadow",
      shadowFormGroupInset: "Form Group Inside Shadow",
      shadowInput: "Input Box Shadow",
			shadowText: "Text Shadow",
			shadowListRow: "List Shadow",
			shadowTableRow: "Table Shadow",
			pluginShadow: "Plugin Shadow",
			//   pluginInset: "Plugin Inside Shadow",
			textarea: "Textarea Shadow",
			pluginInsideLeftShadow: "Plugin Inside Left Shadow",
			pluginInsideRightShadow: "Plugin Inside Right Shadow",
			pluginInsideTopShadow: "Plugin Inside Top Shadow",
			pluginInsideBottomShadow: "Plugin Inside Bottom Shadow",
			shortcutMenu: "Shortcut Menu Shadow (Chat window action icons)",
			shortcutMenuInset: "Shortcut Menu Inside Shadow (Chat window action icons)",
			// smallButton: "Small Button Shadow",
			// sidePopup: "Side Popup Shadow",
		};
		return labels[key] || key;
	};

	handleInputChangeShadows = (type, value) => {
		this.setState((prevState) => ({
		shadows: {
			...prevState.shadows,
			[type]: value,
		},
		}));
	};
	/**Shadow end */

	Capitalize(str) {
	return str?.charAt(0)?.toUpperCase() + str?.slice(1) || "";
	}
	addFunc = (e) => {
    this.setState((prevState) => ({
      fontDetails: [
        ...prevState.fontDetails,
        {
          index: Math.random(),
          FontType: "",
          FontId: "",
          fontSize: "",
          fontWeight: "",
          letterSpacing: "",
          lineHeight: "",
          TopSpace: "",
          BottomSpace: "",
          varient_id: "",
        },
      ],
    }));
  };
	/**Font management start */
	addMoreFunc = (e) => {
    return this.state.fontDetails.map((val, idx) => {
      let FontType = `FontType${idx}`,
        fontWeight = `fontWeight${idx}`,
        FontSize = `FontSize${idx}`,
        letterSpacing = `letterSpacing${idx}`,
        lineHeight = `lineHeight${idx}`,
        TopSpace = `TopSpace${idx}`,
        BottomSpace = `BottomSpace${idx}`,
        errorfile = `errorfile${idx}`;
      return (
        <>
          <div className="form-row mb-0" key={val.index}>
            <div className="form-left">
              <div className="form-group">
                <label className="pb-0">
                  {/* Apply font : */}
                  Font Apply to {this.Capitalize(val.listName)}
                </label>
                <div className="mt-2">{val.FontTypeCheck}</div>
              </div>
            </div>
          </div>
          <div className="form-row" key={val.index}>
            {this.varientField(
              val.fontId,
              val.fontFamily,
              val.FontType,
              idx,
              val,
              val.index
            )}
          </div>
        </>
      );
    });
  };

	regularOption = (val) => {
    return (
      <>
        <option
          value="200"
          className="fontVarientName"
          selected={val.fontWeight === "200"}
        >
          Extra Light 200
        </option>
        <option
          value="300"
          className="fontVarientName"
          selected={val.fontWeight === "300"}
        >
          Light 300
        </option>
        <option
          value="400"
          className="fontVarientName"
          selected={val.fontWeight === "400"}
        >
          Regular 400
        </option>
        <option
          value="500"
          className="fontVarientName"
          selected={val.fontWeight === "500"}
        >
          Medium 500
        </option>
        <option
          value="600"
          className="fontVarientName"
          selected={val.fontWeight === "600"}
        >
          Semi Bold 600
        </option>
        <option
          value="700"
          className="fontVarientName"
          selected={val.fontWeight === "700"}
        >
          Bold 700
        </option>
        <option
          value="800"
          className="fontVarientName"
          selected={val.fontWeight === "800"}
        >
          Extra Bold 800
        </option>
        <option
          value="900"
          className="fontVarientName"
          selected={val.fontWeight === "900"}
        >
          Black 900
        </option>
      </>
    );
  };

  handleFileChangeVarients = async (e, idx, fontLabel, fontValue) => {
    let font_file = `font_file${idx}`;
    let fontDetails = [...this.state.fontDetails];

    fontDetails[idx] = {
      ...fontDetails[idx],
      fontWeight: e.target.value,
    };
    fontDetails[e.target.dataset.id]["varient_id"] = idx;
    fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
    let selectedFont = e.target.name;
    this.setState({ fontDetails }, () => {
      console.log(this.state.fontDetails, "Updated fontDetails");
    });
  };

  varientField = (FontId, FontFamily, FontType, idx, val, selIndex) => {
    const fontArray = this.state.fonttype.map((fonttype, index) => ({
      id: index,
      name: fonttype,
    }));

    console.log(fontArray, "this is for font array");
    // Dynamically create select list
    let fonts = [];
    fontArray.map((item) =>
      fonts.push({
        label: item.name.label,
        value: item.name.value,
        fontStyles: item.name.tf_fontStyles,
        typeIs: item.name.tf_font_type,
        type: item.name.type,
      })
    );

    let fontWeight = `fontWeight${idx}`,
      FontSize = `FontSize${idx}`,
      FontIndId = `FontId${idx}`,
      letterSpacing = `letterSpacing${idx}`,
      lineHeight = `lineHeight${idx}`,
      TopSpace = `TopSpace${idx}`,
      BottomSpace = `BottomSpace${idx}`,
      radius = `radius${idx}`,
      fontFamilyError = `fontFamilyError${idx}`,
      fontVariantError = `fontVariantError${idx}`,
      fontSizeError = `fontSizeError${idx}`,
      letterSpacingError = `letterSpacingError${idx}`,
      topSpaceError = `topSpaceError${idx}`,
      bottomSpaceError = `bottomSpaceError${idx}`,
      radiusError = `radiusError${idx}`
      ;
    //if(FontType !=='smallButton' && FontType!=='largeButton'){
    return (
      <>
        <div className="form-left">
          <div className="form-group">
            <label>Font Family<span class="required" style={{ color: "red" }} > * </span> :</label>
            <div>
              <select
                name="font_id"
                className="form-control"
                id={FontType}
                data-id={idx}
                value={val.font_id?.toString() || ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  const selectedOption = fonts.find(
                    (option) => option.value === selectedValue
                  );
                  this.handleFileChange(
                    e,
                    idx,
                    selectedOption?.label,
                    selectedOption?.value
                  );
                }}
              >
                <option value="">Select Font</option>

                <optgroup label="System Fonts">
                  {fonts
                    .filter((f) => f.type === "system_font")
                    .map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                </optgroup>
                <optgroup label="Google Fonts">
                  {fonts
                    .filter((f) => f.type === "google_font")
                    .map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                </optgroup>
                {console.log(fonts, "this is for fonts label")}
                <optgroup label="Custom Fonts">
                  {fonts
                    .filter((f) => f.type === "normal_font")
                    .map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                </optgroup>
              </select>
              <div className={fontFamilyError}></div>
            </div>
          </div>
        </div>
        <div className="form-right">
          <div className="form-group">
            <label>Font Variant<span class="required" style={{ color: "red" }} > * </span> :</label>
            <div>
              <select
                name="fontWeight"
                className="form-control"
                id={FontType}
                data-id={idx}
                onChange={(e) => this.handleFileChangeVarients(e, idx)}
              >
                <option value="" className="fontVarientName">
                  Select Variant
                </option>
                {console.log(this.state.fontDetails, "this is fontsdetails")}
                {this.state.fontDetails[idx]?.variants?.map((variant) => (
                  <option
                    key={variant.value}
                    value={variant.value || val.fontWeight}
                    selected={val.fontWeight == variant.value ? true : false}
                  >
                    {variant.label} {variant.value}
                  </option>
                ))}
              </select>

              <div className={fontVariantError}></div>
            </div>
          </div>
        </div>

        <div className="form-left">
          <div className="form-group">
            <label>Font Size<span class="required" style={{ color: "red" }} > * </span> :</label>
            <div>
              <input
                type="text"
                name="fontSize"
                onChange={(e) => this.handleFileChange(e, idx)}
                //onChange={this.onFileChange}
                value={val.fontSize}
                data-id={idx}
                id={FontSize}
              />

              <div className={fontSizeError}></div>
            </div>
          </div>
        </div>
        <div className="form-right">
          <div className="form-group">
            <label>Letter Spacing<span class="required" style={{ color: "red" }} > * </span> :</label>
            <div>
              <input
                type="text"
                name="letterSpacing"
                onChange={(e) => this.handleFileChange(e, idx)}
                //onChange={this.onFileChange}
                value={val.letterSpacing}
                data-id={idx}
                id={letterSpacing}
              />

              <div className={letterSpacingError}></div>
            </div>
          </div>
        </div>
        {console.log(FontType, "thi is fonttype")}
        {FontType == "smallbutton" ||
        FontType == "largebutton" ||
        FontType == "pluginOpenButton" ? (
          <>
            <div className="form-left">
              <div className="form-group">
                <label>Top Space<span class="required" style={{ color: "red" }} > * </span> :</label>
                <div>
                  <input
                    type="text"
                    name="topSpace"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.topSpace}
                    data-id={idx}
                    id={TopSpace}
                  />

                  <div className={topSpaceError}></div>
                </div>
              </div>
            </div>
            <div className="form-right">
              <div className="form-group">
                <label>Bottom Space<span class="required" style={{ color: "red" }} > * </span> :</label>
                <div>
                  <input
                    type="text"
                    name="bottomSpace"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.bottomSpace}
                    data-id={idx}
                    id={BottomSpace}
                  />
                  <div className={bottomSpaceError}></div>
                </div>
              </div>
            </div>
            <div className="form-left">
              <div className="form-group">
                <label>Radius<span class="required" style={{ color: "red" }} > * </span> :</label>
                <div>
                  <input
                    type="text"
                    name="radius"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.radius}
                    data-id={idx}
                    id={radius}
                  />

                  <div className={radiusError}></div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </>
    );
  };
  varientFieldpld = (FontId, FontFamily, FontType, idx, val, selIndex) => {
    console.log(FontType);

    console.log("done");
    const fontArray = this.state.fonttype.map((fonttype, index) => ({
      id: index,
      name: fonttype,
    }));
    // Dynamically create select list
    let fonts = [];
    fontArray.map((item) =>
      fonts.push({
        label: item.name.label,
        value: item.name.value,
        fontStyles: item.name.tf_fontStyles,
        typeIs: item.name.tf_font_type,
      })
    );

    console.log(fontArray);

    let fontWeight = `fontWeight${idx}`,
      FontSize = `FontSize${idx}`,
      FontIndId = `FontId${idx}`,
      letterSpacing = `letterSpacing${idx}`,
      lineHeight = `lineHeight${idx}`,
      TopSpace = `TopSpace${idx}`,
      radius = `radius${idx}`,
      BottomSpace = `BottomSpace${idx}`,
      errorfile = `errorfile${idx}`;
    //if(FontType !=='smallButton' && FontType!=='largeButton'){
    return (
      <>
        <div className="form-left">
          <div className="form-group">
            <label>Font Family :</label>
            <div>

              <select
                name="font_id"
                className="form-control"
                id={FontType}
                data-id={idx}
                onChange={(e) => this.handleFileChange(e, idx, selIndex)}
              >
                <option value="" className="fontFamilyId">
                  {" "}
                  Select Font
                </option>
                {fonts.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    selected={val.font_id == option.value ? true : false}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
              <div className={errorfile}></div>
            </div>
          </div>
        </div>
        <div className="form-right">
          <div className="form-group">
            <label>Font Variant :</label>
            <div>
              <select
                name="fontWeight"
                className="form-control"
                id={FontType}
                data-id={idx}
                onChange={(e) => this.handleFileChange(e, idx)}
              >
                <option value="" className="fontVarientName">
                  {" "}
                  Select Variant
                </option>
                <option
                  value="200"
                  className="fontVarientName"
                  selected={val.fontWeight == "200" ? true : false}
                >
                  {" "}
                  Extra Light200
                </option>
                <option
                  value="300"
                  className="fontVarientName"
                  selected={val.fontWeight == "300" ? true : false}
                >
                  {" "}
                  Light 300
                </option>
                <option
                  value="400"
                  className="fontVarientName"
                  selected={val.fontWeight == "400" ? true : false}
                >
                  {" "}
                  Regular 400
                </option>
                <option
                  value="500"
                  className="fontVarientName"
                  selected={val.fontWeight == "500" ? true : false}
                >
                  {" "}
                  Medium 500
                </option>
                <option
                  value="600"
                  className="fontVarientName"
                  selected={val.fontWeight == "600" ? true : false}
                >
                  {" "}
                  Semi Bold 600
                </option>
                <option
                  value="700"
                  className="fontVarientName"
                  selected={val.fontWeight == "700" ? true : false}
                >
                  {" "}
                  Bold 700
                </option>
                <option
                  value="800"
                  className="fontVarientName"
                  selected={val.fontWeight == "800" ? true : false}
                >
                  {" "}
                  Extra Bold 800
                </option>
                <option
                  value="900"
                  className="fontVarientName"
                  selected={val.fontWeight == "900" ? true : false}
                >
                  Black 900
                </option>
              </select>

              <div className={errorfile}></div>
            </div>
          </div>
        </div>
        <div className="form-left">
          <div className="form-group">
            <label>Font Size :</label>
            <div>
              <input
                type="text"
                name="fontSize"
                onChange={(e) => this.handleFileChange(e, idx)}
                //onChange={this.onFileChange}
                value={val.fontSize}
                data-id={idx}
                id={FontSize}
              />

              <div className={errorfile}></div>
            </div>
          </div>
        </div>
        <div className="form-right">
          <div className="form-group">
            <label>Letter Spacing :</label>
            <div>
              <input
                type="text"
                name="letterSpacing"
                onChange={(e) => this.handleFileChange(e, idx)}
                //onChange={this.onFileChange}
                value={val.letterSpacing}
                data-id={idx}
                id={letterSpacing}
              />

              <div className={errorfile}></div>
            </div>
          </div>
        </div>
        {FontType == "smallButton" ||
        FontType == "largeButton" ||
        FontType == "pluginOpenButton" ? (
          <>
            <div className="form-left">
              <div className="form-group">
                <label>Top Space :</label>
                <div>
                  <input
                    type="text"
                    name="topSpace"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.topSpace}
                    data-id={idx}
                    id={TopSpace}
                  />

                  <div className={errorfile}></div>
                </div>
              </div>
            </div>
            <div className="form-right">
              <div className="form-group">
                <label>Bottom Space :</label>
                <div>
                  <input
                    type="text"
                    name="bottomSpace"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.bottomSpace}
                    data-id={idx}
                    id={BottomSpace}
                  />
                  <div className={errorfile}></div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </>
    );
  };
	handleFileChange = async (e, idx, fontLabel, fontValue) => {
    let font_file = `font_file${idx}`;
    let fontDetails = [...this.state.fontDetails];
    fontDetails[e.target.dataset.id]["varient_id"] = idx;
    fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
    let selectedFont = e.target.name;
    if (fontValue) {
      try {
        const response = await axios.get(`${apiUrl}font/getvarientlistdetail`, {
          params: {
            id: fontValue,
            name: fontLabel,
          },
        });
        if (response.data.variants) {
          fontDetails[idx] = {
            ...fontDetails[idx],
            variants: response.data.variants,
          };
          console.log(response.data.variants, "this is fortvarientrecords");
        }
      } catch (error) {
        console.error("Error fetching font variants:", error);
      }
    }

    this.setState({ fontDetails }, () => {
      console.log(this.state.fontDetails, "Updated fontDetails");
    });
  };
	/**Font management end */

  	render() {
  	const {selectedOption} = this.state;

    return (
      <div className="wrapper"> 
	 	<Header />
    	<MenuSidebar currentpage="themes"  currentTab="common" />  
		<div className="content">	
			<div className="content-wrapper">
				<div class="content-wrapper-before"></div>
				<div className="form-wrapper leaa-admin-head card">
					<div className="success_message"></div>
					<div>
						<a className="btn" href="/theme">Back</a>
					</div>
					<div className="title">
						<h4>Add Theme</h4>
					</div>
					<form className="login" id="login" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }}>			
						<div className="form-row">
							<div className='form-left'>
								<div className="form-group">
									<label>Title<span class="required" style={{ color: "red" }} > * </span></label>
									<input type="text" name="title" onChange={this.handleInputChange} className="form-control" value={this.state.title} autoComplete="off" />
									<div className="errortitle"></div>
								</div>
							</div>
							<div className='form-right'>
								<div className="form-group">					
									<label>Status</label>
									<Select 
									value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
									options={lang.common.status_option} 
									onChange={this.handleChange}
									/>
								</div>
							</div>
						</div>

            <div className="title">
              <h4>AI Screen Management</h4>
            </div>
            <div className="form-row">
              <div className="form-left">
                <div className="form-group">
                  <label>Sidebar Expended size (px)<span class="required" style={{ color: "red" }} > * </span>:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ai_side_menu_width"
                    onChange={this.handleInputChange}
                    value={this.state.ai_side_menu_width}
                  />
                  <div className="errorsai_side_menu_width"></div>
                </div>

                <div className="form-group">
                  <label>Sidebar Icon Size (px)<span class="required" style={{ color: "red" }} > * </span>:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="st_aisidebar_icon_width"
                    onChange={this.handleInputChange}
                    value={this.state.st_aisidebar_icon_width}
                  />
                  <div className="errorsst_aisidebar_icon_width"></div>
                </div>
              </div>
              <div className="form-right">
                <div className="form-group">
                  <label>Sidebar Collapsed size (px)<span class="required" style={{ color: "red" }} > * </span>:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="st_aisidebar_collapsed_width"
                    onChange={this.handleInputChange}
                    value={this.state.st_aisidebar_collapsed_width}
                  />
                  <div className="errorsst_aisidebar_collapsed_width"></div>
                </div>
              </div>
            </div>

            	<div className="title">
							<h4>Image Size Management</h4>
						</div> 

						<div className="form-row mb-0"><div className="form-left"><div class="form-group"><h4 className="title text-start">Ads Image : <i className="fa fa-info-circle ms-2 fs-6 cursor-pointer"></i></h4></div></div></div>

						<div className="form-row">		
							<div className="form-left">					
								<div className="form-group">					
									<label
									>
										Ads image max height (px):
									</label>
									<input type="text" className="form-control" name="adsimageheight"   />
									<div className="errorpluginRadius"></div>
								</div>
								
							</div>
							<div className="form-right">					
								<div className="form-group">					
									<label>
										Ads image max width (px):
									</label>
									<input type="text" className="form-control" name="adsimagewidth"   />
									<div className="errorpluginRadius"></div>
								</div>
								
							</div>
						</div>	


						<div className="form-row mb-0"><div className="form-left"><div class="form-group"><h4 className="title text-start">Membership Image : <i className="fa fa-info-circle ms-2 fs-6 cursor-pointer"></i></h4></div></div></div>

						<div className="form-row">		
							<div className="form-left">					
								<div className="form-group">					
									<label
									>
										Membership image max height (px):
									</label>
									<input type="text" className="form-control" name="membershipimageheight"   />
									<div className="errorpluginRadius"></div>
								</div>
								
							</div>
							<div className="form-right">					
								<div className="form-group">					
									<label>
										Membership image max width (px):
									</label>
									<input type="text" className="form-control" name="membershipimagewidth"   />
									<div className="errorpluginRadius"></div>
								</div>
								
							</div>
						</div>	


						<div className="title">
							<h4>Radius Management</h4>
						</div> 
						<div className="form-row">		
							<div className="form-left">					
								<div className="form-group">					
									<label>Plugin Radius (px):</label>
									<input type="text" className="form-control" name="pluginRadius"  onChange={this.handleInputChange}  value={this.state.pluginRadius} />
									<div className="errorpluginRadius"></div>
								</div>
								<div className="form-group">
									<label>Input Box Radius (px):</label>
									<input type="text" className="form-control" name="inputRadius"  onChange={this.handleInputChange} value={this.state.inputRadius}/>
									<div className="errorinputRadius"></div>
								</div>	
                <div className="form-group">					
									<label>Dashboard Grid Radius (px):</label>
									<input type="text" className="form-control" name="dashboardGridRadius"  onChange={this.handleInputChange}  value={this.state.dashboardGridRadius} />
									<div className="errordashboardGridRadius"></div>
								</div>
								<div className="form-group">
									<label>List Row Radius (px):</label>
									<input type="text" className="form-control" name="listRowRadius"  onChange={this.handleInputChange} value={this.state.listRowRadius}/>
									<div className="errorlistRowRadius"></div>
								</div>	
								<div className="form-group">
									<label>Form Group Radius (px):</label>
									<input type="text" className="form-control" name="formGroupRadius"  onChange={this.handleInputChange} value={this.state.formGroupRadius}/>
									<div className="errorformGroupRadius"></div>
								</div>	
								<div className="form-group">
									<label>Top Popup Radius (px):</label>
									<input type="text" className="form-control" name="topPopupRadius"  onChange={this.handleInputChange} value={this.state.topPopupRadius}/>
									<div className="errortopPopupRadius"></div>
								</div>	
							</div>
							<div className="form-right">					
								<div className="form-group">
									<label>Dropdown Menu Radius (Bell notification, Group menu in listing screen, Message box, Address dropdown) (px):</label>
									<input type="text" className="form-control" name="dropdownRadius"  onChange={this.handleInputChange}  value={this.state.dropdownRadius} />
									<div className="errordropdownRadius"></div>
								</div>
								<div className="form-group">
									<label>Textarea Radius (px):</label>
									<input type="text" className="form-control" name="textareaRadius"  onChange={this.handleInputChange} value={this.state.textareaRadius}/>
									<div className="errortextareaRadius"></div>
								</div>
                <div className="form-group">
									<label>Dashboard List Radius (px):</label>
									<input type="text" className="form-control" name="dashboardListRadius"  onChange={this.handleInputChange}  value={this.state.dashboardListRadius} />
									<div className="errordashboardListRadius"></div>
								</div>
								<div className="form-group">
									<label>Map Popup Radius (px):</label>
									<input type="text" className="form-control" name="mapPopupRadius"  onChange={this.handleInputChange} value={this.state.mapPopupRadius}/>
									<div className="errormapPopupRadius"></div>
								</div>
								<div className="form-group">
									<label>AI Screen Textarea Radius (px):</label>
									<input type="text" className="form-control" name="mainAITextareaRadius"  onChange={this.handleInputChange} value={this.state.mainAITextareaRadius}/>
									<div className="errormainAITextareaRadius"></div>
								</div>
							</div>
						</div>

						{/* Shadow Management Start */}
				         <div className="title">
                    <h4>Shadow Management</h4>
                  </div>
                  <div className="form-row">
                    {Object.entries(this.state.shadows).map(([key, value]) => (
                      <div className="form-left" key={key}>
                        <div className="form-group admin-panel-btn">
                          <label>{this.labelFor(key)}:</label>
                          <input
                            value={value}
                            type="text"
                            autoComplete="off"
                            className="form-control"
                            style={{ width: "85%" }}
                            onChange={(e) =>
                              this.handleInputChangeShadows(key, e.target.value)
                            }
                          />
                          <button
                            type="button"
                            className='shadow-edit-icon'
                            onClick={() => this.confirmPopup(key)}
                            style={{
                              color: "white",
                              padding: "14px",
                              minWidth: "47px",
                              height: "48px",
                              backgroundColor: "rgb(5, 31, 58)",
                              borderRadius: "0px 5px 5px 0px",
                            }}
                          >
                            <i>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#fff"
                                viewBox="32 -0.03 543.87 512.03"
                              >
                                <path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path>
                              </svg>
                            </i>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="form-row">
                    <div className="input-popup-action">
                      <a
                        className="popup-close position-absolute cursor-pointer"
                        onClick={this.handleCancel}
                      >
                        X
                      </a>
                      <div className="title">
                        <h4>{this.labelFor(this.state.activeShadowType)}</h4>
                      </div>

                      <div className="shadow-picker-container d-flex w-100 justify-content-between">
                        <ShadowPicker
                          value={
                            this.state.shadows[this.state.activeShadowType] ||
                            ""
                          }
                          onChange={(value) => this.handleShadowChange(value)}
                          className="shadow-picker"
                        />

                        <div
                          className="shadow-box"
                          style={{
                            boxShadow:
                              this.state.shadows[this.state.activeShadowType] ||
                              "none",
                          }}
                        ></div>
                      </div>
                      <div className="d-flex w-100 justify-content-end gap-2 mt-5">
                        <a className="primary-btn" onClick={this.handleSubmit}>
                          Save
                        </a>
                      </div>
                    </div>
                  </div>
						{/* Shadow Management End */}

						{/* Font Management End */}
						<div className="title">
							<h4>Font Management</h4>
						</div> 
						<div className="form-row">		
							<div className="form-left">					
								<div className="form-group">
									<label>Line Height</label>
									<input type="text" className="form-control" name="line_height" onChange={this.handleInputChange}  value={this.state.line_height}/>
									<div className="errorline_height"></div>
								</div>
							</div>
						</div>
					
						{this.addMoreFunc()}	
						{/* Font Management End */}
								
						<div className='white-space-110px'></div>
					
						<div className="btn-group export">	
							<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true && <span className="load-data"></span> }Submit
							</button>
						</div>
					</form>
				</div>
			</div>	
		</div>
    </div>
    );
  }
}



export default withRouter(Add);